'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const styleEncapsulation = require('@zapier/style-encapsulation');
const React = require('react');
const components_display_VisuallyHidden_useIsKeyHeld = require('./useIsKeyHeld.cjs.js');

const Styles = styleEncapsulation.labelStyles("VisuallyHidden", {
  root: react.css`
    position: absolute;
    overflow: hidden;
    clip: rect(0 0 0 0);
    height: 1px;
    width: 1px;
    margin: -1px;
    padding: 0;
    border: 0;
  `
});
const VisuallyHidden = (props) => {
  const isAltKeyHeld = components_display_VisuallyHidden_useIsKeyHeld.useIsKeyHeld("Alt");
  if (isAltKeyHeld) {
    return react.jsx(React.Fragment, null, props.children);
  }
  return react.jsx("span", { css: Styles.root, "data-testid": "visually-hidden" }, props.children);
};

exports.VisuallyHidden = VisuallyHidden;
//# sourceMappingURL=VisuallyHidden.cjs.js.map
